import { CSS } from '@grupoboticario/flora-react'

export const topSpacerCss: CSS = {
  marginTop: '$5'
}

export const horizontalScrollCss: CSS = {
  overflowX: 'auto'
}

export const filterSpacerCss: CSS = {
  marginTop: '$7'
}

export const tableSpacerCss: CSS = {
  marginTop: '$5'
}
